<template>
  <v-app :key="appStateKey">
    <template>
      <v-main>
        <router-view :key="$route.fullPath" />
      </v-main>
    </template>
    <bm-loader />

    <modal-dialog-stack />
  </v-app>
</template>

<script setup lang="ts">
import BmLoader from "@/components/dialogs/BmLoader.vue";
import appStore from "@/store/modules/appStore";
import versionManager from "@/store/modules/versionManager";
import { watch, computed } from "vue";
import { usePerformanceMeasurements } from "@/app/performanceMeasurements";
import { makeRef } from "@/components/composables/componentTools";
import { useVuetify } from "@/plugins/vuetify";
import ModalDialogStack from "@/components/platform/common/ModalDialogStack.vue";

const { $vuetify } = useVuetify();

const drawer = makeRef<boolean | null>(null);

const appStateKey = computed(() => appStore.state.appStateKey);
const requiresForcedRefresh = computed(
  () => versionManager.requiresForcedRefresh.value
);

const requiresForcedRefreshWatcher = () => {
  if (requiresForcedRefresh.value) {
    // eslint-disable-next-line no-console
    console.log("Version mismatched for too long. Force reloading...");
    window.location.reload();
  }
};

watch(requiresForcedRefresh, requiresForcedRefreshWatcher);

usePerformanceMeasurements();
</script>
<style lang="sass">
// Hides the scroll bar when not needed
html
  overflow: auto

// @FIXME: Scrolling On Mac Devices issue caused by OSX setting to hide scrollbars when using trackpad
// SEE: https://stackoverflow.com/questions/7855590/preventing-scroll-bars-from-being-hidden-for-macos-trackpad-users-in-webkit-blin
</style>
